import { render } from "./popUpReferencias.vue?vue&type=template&id=388172cd&scoped=true"
import script from "./popUpReferencias.vue?vue&type=script&lang=js"
export * from "./popUpReferencias.vue?vue&type=script&lang=js"

import "./popUpReferencias.vue?vue&type=style&index=0&id=388172cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388172cd"]])

export default __exports__